<div class="wizard-wrapper pg-glass-modal">
  
  <!-- Header del Selector -->
  <div class="wizard-header">
    <button class="wiz-back-btn" (click)="dismiss()">
      <ion-icon name="close"></ion-icon>
    </button>
    <div class="step-header-text">
      <h2 class="step-question" style="font-size: 1.25rem; font-weight: 800; color: #1a252f;">{{ title }}</h2>
    </div>
  </div>

  <!-- Buscador Premium (Fijo, integrado sin cortes) -->
  <div class="step-input-area">
    <div class="big-input-box" [class.has-value]="searchText">
      <ion-icon name="search-outline" class="bi-search"></ion-icon>
      <input
        class="big-input"
        type="text"
        [value]="searchText"
        (input)="filterItems($event)"
        [placeholder]="placeholder"
        autofocus
      />
      <ion-icon name="close-circle" class="bi-clear"
        *ngIf="searchText" (click)="searchText = ''; sortAndFilterItems()"></ion-icon>
    </div>
  </div>

  <ion-content class="wizard-content">
    <div class="wizard-body" style="padding: 16px 20px;">
      
      <!-- Lista de Elementos Ordenados (Tarjeta de Cristal) -->
      <div class="suggest-list">
        
        <!-- Elemento para Crear Nuevo si no existe -->
        <div class="suggest-item suggest-create"
          *ngIf="entity !== 'TURNO' && entity !== 'UNIDAD' && searchText && !doesItemExist(searchText)"
          (click)="createNewEntity()">
          <div class="suggest-avatar create"><ion-icon name="add"></ion-icon></div>
          <span>Crear "<strong>{{ searchText }}</strong>"</span>
          <ion-icon name="chevron-forward" class="suggest-arrow"></ion-icon>
        </div>

        <!-- Items filtrados -->
        <div class="suggest-item" *ngFor="let item of filteredItems" 
          [class.selected]="isSelected(item)"
          (click)="selectItem(item)">
          <div class="suggest-avatar" [class.biz]="entity === 'CLIENTE'" [class.loc]="entity === 'DIRECCION'" [class.area-avatar]="entity === 'AREA'" [class.est-avatar]="entity === 'ESTRUCTURA'">
            <ion-icon *ngIf="entity === 'DIRECCION'" name="pin"></ion-icon>
            <ion-icon *ngIf="entity === 'AREA'" name="map-outline"></ion-icon>
            <ion-icon *ngIf="entity === 'ESTRUCTURA'" name="layers-outline"></ion-icon>
            <ion-icon *ngIf="entity === 'TURNO'" [name]="item.id === 'NOCTURNO' ? 'moon' : 'sunny'"></ion-icon>
            <ion-icon *ngIf="entity === 'UNIDAD'" name="speedometer-outline"></ion-icon>
            <span *ngIf="entity !== 'DIRECCION' && entity !== 'AREA' && entity !== 'ESTRUCTURA' && entity !== 'TURNO' && entity !== 'UNIDAD'">{{ item.nombre.charAt(0) }}</span>
          </div>
          <span style="flex: 1; font-weight: 500;">{{ item.nombre }}</span>
          
          <!-- Indicador visual (Check para multiselección / check o flecha para única) -->
          <div class="suggest-indicator">
            <ion-icon *ngIf="isMultiSelect && isSelected(item)" name="checkbox" class="check-active"></ion-icon>
            <ion-icon *ngIf="isMultiSelect && !isSelected(item)" name="square-outline" class="check-inactive"></ion-icon>
            <ion-icon *ngIf="!isMultiSelect && isSelected(item)" name="checkmark-circle" class="check-active" style="color: #27ae60; font-size: 1.35rem;"></ion-icon>
            <ion-icon *ngIf="!isMultiSelect && !isSelected(item)" name="chevron-forward" class="suggest-arrow"></ion-icon>
          </div>
        </div>

        <!-- Sin resultados -->
        <div class="suggest-item" *ngIf="filteredItems.length === 0 && !searchText" style="justify-content: center; color: #95a5a6; font-weight: 500; font-size: 0.95rem; padding: 24px;">
          No hay elementos disponibles
        </div>

      </div>

    </div>
  </ion-content>

  <!-- Footer de Acciones para Selección Múltiple -->
  <div class="wizard-footer" *ngIf="isMultiSelect">
    <button class="wiz-confirm-btn" (click)="confirmSelection()" [disabled]="localSelectedItems.length === 0">
      <ion-icon name="checkmark-circle-outline"></ion-icon>
      <span>Confirmar Selección ({{ localSelectedItems.length }})</span>
    </button>
  </div>
</div>
